/* eslint-disable react/no-array-index-key */
/* eslint-disable tailwindcss/no-custom-classname */
import classNames from 'classnames';
import React from 'react';
import StarIcon from '../../icons/Star';

interface BulletsProps {
  bullets: string[];
  className?: string;
}

export const Bullets: React.FC<BulletsProps> = ({ bullets, className }) => {
  return (
    <div className={classNames('', className)}>
      {bullets.length > 0 && (
        <ul className="list-none p-0 font-font-weight/body-2 text-text/primary text-font-size/body-2 leading-line-height/body-2-relaxed">
          {bullets.map((bullet, index) => (
            <li key={index} className="mb-2 flex items-start">
              <span className="mr-2 mt-1 shrink-0">
                <StarIcon className="text-text/accent" />
              </span>
              <span className="flex-1">{bullet}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
